import "./style.scss";

import { FlyoutContent } from "@amzn/stencil-react-components/flyout";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC, useState } from "react";

import { HardwareOrderSupport } from "./HardwareOrderSupport/HardwareOrderSupport";
import { MessageConfirmation } from "./HardwareOrderSupport/MessageConfirmation";
import { HardwareSupportOptions } from "./HardwareSupportOptions";

interface HardwareSupportFlyoutProps {
  onClose: () => void;
  onButtonClick?: () => void;
}

type ComponentType = "options" | "order" | "message";

/**
 * Represents a configuration object for a UI component.
 * @interface
 * @property {React.ReactNode} component - The React component to be rendered.
 */
interface ComponentConfig {
  component: React.ReactNode;
}

export const HardwareSupportFlyout: FC<HardwareSupportFlyoutProps> = ({ onClose, onButtonClick = () => {} }) => {
  const [activeComponent, setActiveComponent] = useState<ComponentType>("options");

  const navigateTo = (component: ComponentType): void => {
    setActiveComponent(component);
  };

  const getComponentConfig = (): ComponentConfig => {
    const configs: Record<ComponentType, ComponentConfig> = {
      options: {
        component: <HardwareSupportOptions onOrderClick={() => navigateTo("order")} onButtonClick={onButtonClick} />,
      },
      order: {
        component: (
          <HardwareOrderSupport
            onBackClick={() => navigateTo("options")}
            onSendMessageClick={() => navigateTo("message")}
          />
        ),
      },
      message: {
        component: <MessageConfirmation />,
      },
    };

    return configs[activeComponent];
  };

  const { component } = getComponentConfig();

  return (
    <FlyoutContent
      titleText={getString("hardwareSupport.hardwareSupportTitle")}
      onCloseButtonClick={onClose}
      maxWidth="600px"
    >
      {component}
    </FlyoutContent>
  );
};
